import React, { useEffect, useRef, useState } from 'react'
import { Box, Heading, Grid, GridItem, Tab, TabList, TabPanel, TabPanels, Tabs, Input, Image, IconButton } from '@chakra-ui/react'
import CustomButton from '../../../../elements/customButton';
import { Document, Page } from 'react-pdf';
import { ViewIcon } from '@chakra-ui/icons';
import OpenFIleDialog from '../../../../elements/OpenFIleDialog';
import CustomToast from '../../../../elements/customToast';
import { getItem, setItem } from '../../../../../utilities/authUtils';
import { detectFileType } from '../../../../../utilities/DownloadDocuments';
import DownloadIcon from '../../../../../assets/images/download.png'
import { analayzeBankStatement } from '../../../../../services/adminServices';
import Loader from '../../../../elements/loader';
import StatementTabs from './StatementTabs';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';
import CreditDebitBarChart from './ReportTables/CreditDebitBarChart';
import TotalTransactionsChart from './ReportTables/TotalTransactionsChart';
import DailyBalanceTrendChart from './ReportTables/DailyBalanceTrendChart';
import FinancialSummary from './ReportTables/FinancialSummary';

export default function FinancialDetails(props) {

    const MONTHLYINCOME = getItem('monthlyIncome')
    const bankRef = useRef()
    const { addToast } = CustomToast()
    const data = props?.userData?.data
    const [inputValues, setInputValues] = useState({})
    const [openModal, setOpenModal] = useState(false)
    const [modalData, setModalData] = useState(null)
    const [currentFileType, setCurrentFileType] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [reportData, setReportData] = useState(null)
    const [passwordbank, setPasswordbank] = useState(null);
    const [passwordsalary, setPasswordsalary] = useState(null);
    const [passworditr, setPasswordItr] = useState(null);
    const [modalPassword, setModalPassword] = useState(null);
    useEffect(() => {
        setInputValues({ ...inputValues, income: MONTHLYINCOME })
    }, [])

    useEffect(() => {
        const fetchPassword = async () => {
            const response = data?.document_data
            setPasswordbank(response.bank_stmt1_password);
            setPasswordsalary(response.salary_slip_1_password);
            setPasswordItr(response.itr_form16_password);
        };

        fetchPassword();
    }, []);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValues({ ...inputValues, [name]: value })
    }

    const fileType = {
        salarySlip: detectFileType(data?.document_data?.salary_slip_1),
        bankStatement: detectFileType(data?.document_data?.bank_statement_1),
        itr: detectFileType(data?.document_data?.itr_form16),
        bankStatement2: detectFileType(data?.document_data?.bank_statement_2),
        proofDofDdelivery: detectFileType(data?.document_data?.proof_of_delivery),
        gstPaidSubmission: detectFileType(data?.document_data?.gst_paid_submission),
        invoiceCopy: detectFileType(data?.document_data?.invoice_copy),
        cp_creditAssessment: detectFileType(data?.document_data?.cp_credit_assessment),
        post_datedCheque: detectFileType(data?.document_data?.post_dated_cheque),
    }

    const handleModal = (data, fileType, password) => {
        setOpenModal(!openModal)
        setModalData(data)
        setCurrentFileType(fileType)
        setModalPassword(password)
    }

    const showOpenFileDialog = () => {
        bankRef.current.click()
    }

    const onChangeFile = (e) => {
        if (e.target.files[0].type !== 'application/pdf') {
            addToast({ message: 'Bank Statement must be a file of type pdf. ', status: 'error' });
            return
        }
        const formData = new FormData()
        formData.append('file', e.target.files[0])
        setIsLoading(true)
        analayzeBankStatement(formData).then((res) => {
            setIsLoading(false)
            console.log(res, 'res')
            if (res?.status === 200) {
                setReportData(res?.data)
                addToast({ message: 'Report Fetched Successfully', status: 'success' })
            } else {
                addToast({ message: 'Something Went Wrong', status: 'error' })
            }
        }).catch((error) => {
            addToast({ message: error, status: 'error' })
            setIsLoading(false)
        })
    }

    const handleNext = () => {
        if (data?.employment_type == "2" || data?.employment_type == "1") {
            if (!inputValues?.income) {
                addToast({ message: 'Please Enter Monthly Income', status: 'error' });
                return
            }
            setItem('monthlyIncome', inputValues?.income)
            props.onClick()
        }
        else if (data?.loanDetails?.product_id == "17") {
            if (!inputValues?.avg_annual_turnover_underwriter) {
                addToast({ message: 'Please Enter Annual Turnover', status: 'error' });
                return
            }
            if (!inputValues?.invoice_amount_underwriter) {
                addToast({ message: 'Please Enter Invoice Amount', status: 'error' });
                return
            }
            if (!inputValues?.company_establishment_underwriter) {
                addToast({ message: 'Please Enter Company Estblishment', status: 'error' });
                return
            }
            setItem('avgInvoiceAmount', inputValues?.invoice_amount_underwriter)
            setItem('AnnualTurnover', inputValues?.avg_annual_turnover_underwriter)
            setItem("CompanyEstabUnderwriter", inputValues?.company_establishment_underwriter)
            props.onClick()
        }
        else if (data?.loanDetails?.product_id == "10") {
            if (!inputValues?.avg_annual_turnover_underwriter) {
                addToast({ message: 'Please Enter Annual Turnover', status: 'error' });
                return
            }
            if (!inputValues?.avg_monthly_turnover) {
                addToast({ message: 'Please Enter Average Monthly Amount', status: 'error' });
                return
            }
            if (!inputValues?.company_establishment_underwriter) {
                addToast({ message: 'Please Enter Company Estblishment', status: 'error' });
                return
            }
            if (!inputValues?.avg_monthly_income) {
                addToast({ message: 'Please Enter Average Monthly Income', status: 'error' });
                return
            }
            setItem('AnnualTurnover', inputValues?.avg_annual_turnover_underwriter)
            setItem("CompanyEstabUnderwriter", inputValues?.company_establishment_underwriter)
            setItem("Avg_monthly_income", inputValues?.avg_monthly_income)
            setItem("Avg_monthly_turnover", inputValues?.avg_monthly_turnover)
            props.onClick()
        }
    }

    return (
        <>
            {isLoading &&
                <div>
                    <Loader />
                </div>
            }
            <Box mt={5}>
                <Grid className="main_grid_container justify-content-between">
                    <GridItem colSpan={7}>
                        <Box className='summary_heading'>
                            <Heading as="h6" className='font-poppins'>Summary</Heading>
                        </Box>
                        {(data?.employment_type == "1" || data?.employment_type == "2") ?
                            <Box className='d-flex card_data' mt={2}>
                                <Heading as="h6" className='font-poppins box_title w-55'>Net Monthly Income</Heading>
                                <Input
                                    type="number"
                                    size="md"
                                    id="income"
                                    name="income"
                                    placeholder="Please Enter Borrowers Monthly Income"
                                    onChange={handleChange}
                                    className="input_box font-poppins"
                                    value={inputValues?.income ?? ''}
                                />
                            </Box>
                            :
                            <Box>
                                <Box className='d-flex card_data' mt={2}>
                                    <Heading as="h6" className='font-poppins box_title w-55'>Net Annual  Turnover</Heading>
                                    <Input
                                        type="number"
                                        size="md"
                                        id="avg_annual_turnover_underwriter"
                                        name="avg_annual_turnover_underwriter"
                                        placeholder="Please Enter Annual Turnover"
                                        onChange={handleChange}
                                        className="input_box font-poppins"
                                        value={inputValues?.avg_annual_turnover_underwriter ?? ''}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </Box>
                                {
                                    data?.loanDetails?.product_id == "17" &&
                                    <Box className='d-flex card_data' mt={2}>
                                        <Heading as="h6" className='font-poppins box_title w-55'>Invoice Amount</Heading>
                                        <Input
                                            type="number"
                                            size="md"
                                            id="invoice_amount_underwriterr"
                                            name="invoice_amount_underwriter"
                                            placeholder="Please Enter Invoice Amount"
                                            onChange={handleChange}
                                            className="input_box font-poppins"
                                            value={inputValues?.invoice_amount_underwriter ?? ''}
                                            onWheel={(e) => e.target.blur()}

                                        />
                                    </Box>
                                }
                                {
                                    data?.loanDetails?.product_id == "10" &&
                                    <Box className='d-flex card_data' mt={2}>
                                        <Heading as="h6" className='font-poppins box_title w-55'>Average Monthly Turnover</Heading>
                                        <Input
                                            type="number"
                                            size="md"
                                            id="avg_monthly_turnover"
                                            name="avg_monthly_turnover"
                                            placeholder="Please Enter Average Month Turnover"
                                            onChange={handleChange}
                                            className="input_box font-poppins"
                                            value={inputValues?.avg_monthly_turnover ?? ''}
                                            onWheel={(e) => e.target.blur()}

                                        />
                                    </Box>
                                }
                                {
                                    data?.loanDetails?.product_id == "10" &&
                                    <Box className='d-flex card_data' mt={2}>
                                        <Heading as="h6" className='font-poppins box_title w-55'>Average Monthly Income</Heading>
                                        <Input
                                            type="number"
                                            size="md"
                                            id="avg_monthly_income"
                                            name="avg_monthly_income"
                                            placeholder="Please Enter Average Monthly Income"
                                            onChange={handleChange}
                                            className="input_box font-poppins"
                                            value={inputValues?.avg_monthly_income ?? ''}
                                            onWheel={(e) => e.target.blur()}

                                        />
                                    </Box>
                                }
                                <Box className='d-flex card_data' mt={2}>
                                    <Heading as="h6" className='font-poppins box_title w-55'>Company Establishment</Heading>
                                    <Input
                                        type="number"
                                        size="md"
                                        id="company_establishment_underwriter"
                                        name="company_establishment_underwriter"
                                        placeholder="Please Enter Company Establishment"
                                        onChange={handleChange}
                                        className="input_box font-poppins"
                                        value={inputValues?.company_establishment_underwriter ?? ''}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </Box>
                            </Box>
                        }
                        <Box mt={6} className='summary_heading'>
                            <Heading as="h6" className='font-poppins'>Bank Statement Analayzer</Heading>
                            <Box className='upload_container upload_analyzer' mt={2}>
                                <CustomButton
                                    className="btn_theme font-poppins"
                                    title='Browse'
                                    onClick={() => showOpenFileDialog()}
                                />
                                <Input
                                    size="md"
                                    name="upload"
                                    type="file"
                                    accept=".pdf"
                                    onChange={(e) => onChangeFile(e)}
                                    className="d-none"
                                    ref={bankRef}
                                />
                                <Heading mt={4} as="p" className="font-poppins note">
                                    Supported File .png, .jpg Upto 5 MB
                                </Heading>
                            </Box>
                        </Box>
                    </GridItem>
                    <GridItem colSpan={5}>
                        <Tabs className='tabs_container details_tabs'>
                            <TabList className='tabs_list' pb={2} overflowX="auto" whiteSpace="nowrap" sx={{
                                scrollbarWidth: 'thin',
                                '&::-webkit-scrollbar': {
                                    height: '6px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: '#ccc',
                                    borderRadius: '10px',
                                },
                            }}>
                                {
                                    (data?.employment_type == "1" || data?.employment_type == "2") &&
                                    <Tab>Salary Slip</Tab>
                                }
                                <Tab>Bank Statement 1</Tab>
                                <Tab>ITR</Tab>
                                {
                                    data?.loanDetails?.product_id == "17" &&
                                    <>
                                        <Tab>Bank Statement 2</Tab>
                                        <Tab>Proof of Delivery</Tab>
                                        <Tab>GST Paid Submission</Tab>
                                        <Tab>Invoice Copy</Tab>
                                    </>

                                }
                                {
                                    data?.cp_id &&
                                    <>
                                        <Tab>Cp Credit Assessment</Tab>
                                        <Tab>Post Dated Cheque</Tab>
                                    </>
                                }
                                {
                                    data?.loanDetails?.product_id == "10" &&
                                    <>
                                        <Tab>Bank Statement 2</Tab>
                                        <Tab>GST Paid Submission</Tab>
                                    </>


                                }
                            </TabList>
                            <TabPanels>
                                {(data?.employment_type == "1" || data?.employment_type == "2") && (
                                    <TabPanel className='tab_panel'>
                                        {data?.document_data?.salary_slip_1 ? (
                                            <Box className="pdf_read">
                                                {fileType.salarySlip === "pdf" ? (
                                                    <Document
                                                        file={data?.document_data?.salary_slip_1}
                                                        options={{ password: passwordsalary }}
                                                        onLoadError={(err) =>
                                                            console.error("Failed to load Salary Slip PDF:", err)
                                                        }
                                                    >
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                ) : (
                                                    <Image src={data?.document_data?.salary_slip_1} />
                                                )}
                                                <Box>
                                                    <IconButton
                                                        onClick={() =>
                                                            handleModal(
                                                                data?.document_data?.salary_slip_1,
                                                                fileType.salarySlip,
                                                                passwordsalary
                                                            )
                                                        }
                                                        className="icon_button_view"
                                                        icon={<ViewIcon />}
                                                    />
                                                    <a
                                                        target="_blank"
                                                        href={data?.document_data?.salary_slip_1}
                                                        rel="noreferrer"
                                                    >
                                                        <IconButton
                                                            className="icon_button_download"
                                                            icon={<Image src={DownloadIcon} className="download-link" />}
                                                        />
                                                    </a>
                                                </Box>
                                            </Box>
                                        ) : (
                                            <Box className="pdf_read no-data">
                                                <Heading as="h6" className="font-poppins">
                                                    No document available
                                                </Heading>
                                            </Box>
                                        )}
                                    </TabPanel>
                                )}

                                <TabPanel className="tab_panel">
                                    {data?.document_data?.bank_statement_1 ? (
                                        <Box className="pdf_read">
                                            {fileType.bankStatement === "pdf" ? (
                                                <Document
                                                    file={data?.document_data?.bank_statement_1}
                                                    options={{ password: passwordbank }}
                                                    onLoadError={(err) =>
                                                        console.error("Failed to load Bank Statement PDF:", err)
                                                    }
                                                >
                                                    <Page pageNumber={1} />
                                                </Document>
                                            ) : (
                                                <Image src={data?.document_data?.bank_statement_1} />
                                            )}
                                            <Box>
                                                <IconButton
                                                    onClick={() =>
                                                        handleModal(
                                                            data?.document_data?.bank_statement_1,
                                                            fileType.bankStatement,
                                                            passwordbank
                                                        )
                                                    }
                                                    className="icon_button_view"
                                                    icon={<ViewIcon />}
                                                />
                                                <a
                                                    target="_blank"
                                                    href={data?.document_data?.bank_statement_1}
                                                    rel="noreferrer"
                                                >
                                                    <IconButton
                                                        className="icon_button_download"
                                                        icon={<Image src={DownloadIcon} className="download-link" />}
                                                    />
                                                </a>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box className="pdf_read no-data">
                                            <Heading as="h6" className="font-poppins">
                                                No document available
                                            </Heading>
                                        </Box>
                                    )}
                                </TabPanel>

                                <TabPanel className="tab_panel">
                                    {data?.document_data?.itr_form16 ? (
                                        <Box className="pdf_read">
                                            {fileType.itr === "pdf" ? (
                                                <Document
                                                    file={data?.document_data?.itr_form16}
                                                    options={{ password: passworditr }}
                                                    onLoadError={(err) =>
                                                        console.error("Failed to load ITR PDF:", err)
                                                    }
                                                >
                                                    <Page pageNumber={1} />
                                                </Document>
                                            ) : (
                                                <Image src={data?.document_data?.itr_form16} />
                                            )}
                                            <Box>
                                                <IconButton
                                                    onClick={() =>
                                                        handleModal(data?.document_data?.itr_form16, fileType.itr, passworditr)
                                                    }
                                                    className="icon_button_view"
                                                    icon={<ViewIcon />}
                                                />
                                                <a
                                                    target="_blank"
                                                    href={data?.document_data?.itr_form16}
                                                    rel="noreferrer"
                                                >
                                                    <IconButton
                                                        className="icon_button_download"
                                                        icon={<Image src={DownloadIcon} className="download-link" />}
                                                    />
                                                </a>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box className="pdf_read no-data">
                                            <Heading as="h6" className="font-poppins">
                                                No document available
                                            </Heading>
                                        </Box>
                                    )}
                                </TabPanel>

                                <TabPanel className="tab_panel">
                                    {data?.document_data?.bank_statement_2 ? (
                                        <Box className="pdf_read">
                                            {fileType.bankStatement2 === "pdf" ? (
                                                <Document
                                                    file={data?.document_data?.bank_statement_2}
                                                    onLoadError={(err) =>
                                                        console.error("Failed to load Bank Statement 2 PDF:", err)
                                                    }
                                                >
                                                    <Page pageNumber={1} />
                                                </Document>
                                            ) : (
                                                <Image src={data?.document_data?.bank_statement_2} />
                                            )}
                                            <Box>
                                                <IconButton
                                                    onClick={() =>
                                                        handleModal(
                                                            data?.document_data?.bank_statement_2,
                                                            fileType.bankStatement2
                                                        )
                                                    }
                                                    className="icon_button_view"
                                                    icon={<ViewIcon />}
                                                />
                                                <a
                                                    target="_blank"
                                                    href={data?.document_data?.bank_statement_2}
                                                    rel="noreferrer"
                                                >
                                                    <IconButton
                                                        className="icon_button_download"
                                                        icon={<Image src={DownloadIcon} className="download-link" />}
                                                    />
                                                </a>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box className="pdf_read no-data">
                                            <Heading as="h6" className="font-poppins">
                                                No document available
                                            </Heading>
                                        </Box>
                                    )}
                                </TabPanel>
                                <TabPanel className='tab_panel'>
                                    {data?.document_data?.proof_of_delivery ?
                                        <Box className='pdf_read'>
                                            {fileType.proofDofDdelivery === 'pdf' ?
                                                <Document file={data?.document_data?.proof_of_delivery}>
                                                    <Page pageNumber={1} />
                                                </Document>
                                                :
                                                <Image src={data?.document_data?.proof_of_delivery} />
                                            }
                                            {data?.document_data?.proof_of_delivery ?
                                                <Box>
                                                    <IconButton onClick={() => handleModal(data?.document_data?.proof_of_delivery, fileType.proofDofDdelivery)} className="icon_button_view"
                                                        icon={<ViewIcon />}
                                                    />
                                                    <a target='_blank' href={data?.document_data?.proof_of_delivery}>
                                                        <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                    </a>
                                                </Box> : null}
                                        </Box> :
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </TabPanel>
                                <TabPanel className='tab_panel'>
                                    {data?.document_data?.gst_paid_submission ?
                                        <Box className='pdf_read'>
                                            {fileType.gstPaidSubmission === 'pdf' ?
                                                <Document file={data?.document_data?.gst_paid_submission}>
                                                    <Page pageNumber={1} />
                                                </Document>
                                                :
                                                <Image src={data?.document_data?.gst_paid_submission} />
                                            }
                                            {data?.document_data?.gst_paid_submission ?
                                                <Box>
                                                    <IconButton onClick={() => handleModal(data?.document_data?.gst_paid_submission, fileType.gstPaidSubmission)} className="icon_button_view"
                                                        icon={<ViewIcon />}
                                                    />
                                                    <a target='_blank' href={data?.document_data?.gst_paid_submission}>
                                                        <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                    </a>
                                                </Box> : null}
                                        </Box> :
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </TabPanel>
                                <TabPanel className='tab_panel'>
                                    {data?.document_data?.invoice_copy ?
                                        <Box className='pdf_read'>
                                            {fileType.invoiceCopy === 'pdf' ?
                                                <Document file={data?.document_data?.invoice_copy}>
                                                    <Page pageNumber={1} />
                                                </Document>
                                                :
                                                <Image src={data?.document_data?.invoice_copy} />
                                            }
                                            {data?.document_data?.invoice_copy ?
                                                <Box>
                                                    <IconButton onClick={() => handleModal(data?.document_data?.invoice_copy, fileType.invoiceCopy)} className="icon_button_view"
                                                        icon={<ViewIcon />}
                                                    />
                                                    <a target='_blank' href={data?.document_data?.invoice_copy}>
                                                        <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                    </a>
                                                </Box> : null}
                                        </Box> :
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </TabPanel>


                                <TabPanel className='tab_panel'>
                                    {data?.document_data?.cp_credit_assessment ?
                                        <Box className='pdf_read'>
                                            {fileType.cp_creditAssessment === 'pdf' ?
                                                <Document file={data?.document_data?.cp_credit_assessment}>
                                                    <Page pageNumber={1} />
                                                </Document>
                                                :
                                                <Image src={data?.document_data?.cp_credit_assessment} />
                                            }
                                            {data?.document_data?.cp_credit_assessment ?
                                                <Box>
                                                    <IconButton onClick={() => handleModal(data?.document_data?.cp_credit_assessment, fileType.cp_creditAssessment)} className="icon_button_view"
                                                        icon={<ViewIcon />}
                                                    />
                                                    <a target='_blank' href={data?.document_data?.cp_credit_assessment}>
                                                        <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                    </a>
                                                </Box> : null}
                                        </Box> :
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </TabPanel>
                                <TabPanel className='tab_panel'>
                                    {data?.document_data?.post_dated_cheque ?
                                        <Box className='pdf_read'>
                                            {fileType.post_datedCheque === 'pdf' ?
                                                <Document file={data?.document_data?.post_dated_cheque}>
                                                    <Page pageNumber={1} />
                                                </Document>
                                                :
                                                <Image src={data?.document_data?.post_dated_cheque} />
                                            }
                                            {data?.document_data?.post_dated_cheque ?
                                                <Box>
                                                    <IconButton onClick={() => handleModal(data?.document_data?.post_dated_cheque, fileType.post_datedCheque)} className="icon_button_view"
                                                        icon={<ViewIcon />}
                                                    />
                                                    <a target='_blank' href={data?.document_data?.post_dated_cheque}>
                                                        <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                    </a>
                                                </Box> : null}
                                        </Box> :
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </GridItem>
                </Grid>
                {reportData &&
                    <Box mt={10}>
                        <Heading as="h2" className='font-poppins card_heading'>Analyzer Statement</Heading>
                        <Grid mt={4} className="main_grid_container justify-content-between">
                            <GridItem colSpan={7}>
                                <FinancialSummary reportData={reportData} />
                            </GridItem>
                            <GridItem colSpan={5}>
                                <TotalTransactionsChart reportData={reportData} />
                            </GridItem>
                        </Grid>
                        <Grid mt={4} className="main_grid_container justify-content-between">
                            <GridItem colSpan={5}>
                                <CreditDebitBarChart reportData={reportData} />
                            </GridItem>
                            <GridItem colSpan={7}>
                                <DailyBalanceTrendChart reportData={reportData} />
                            </GridItem>
                        </Grid>
                        <StatementTabs reportData={reportData} />
                    </Box>
                }
                <Box className="kyc_actions btn_gap " mb={4} mt={4}>
                    <CustomButton size="md" type="submit" title="Next" className="btn_theme font-poppins" onClick={handleNext} />
                </Box>
                <OpenFIleDialog handleModal={handleModal} openModal={openModal} fileType={currentFileType} modalData={modalData} password={modalPassword} />
            </Box>
        </>
    )
}
